<template>
  <div class="renewManage">
    <div class="renewManage__l">
      <el-menu
      :default-active="$route.name"
      class="el-menu-vertical-demo"
      active-text-color="#409EFF"
      text-color="#666"
      @select="handleClose">
      <el-menu-item index="renewPrice">
        <i class="el-icon-menu"></i>
        <span slot="title">续费单价管理</span>
      </el-menu-item>
      <el-menu-item index="userRecoard">
        <i class="el-icon-document"></i>
        <span slot="title">用户续费记录</span>
      </el-menu-item>
    </el-menu>
    </div>
    <div class="renewManage__r">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {

    }
  },
  methods:{
    handleClose(key, keyPath) {
      this.$router.push('/renewManage/'+key);
    }
  }
}
</script>
<style lang="scss" scoped>
.renewManage{
  display: flex;
  justify-content: left;
  flex-wrap: nowrap;
  height: 100%;
  background: #edf2f8;
  padding:20px;
  box-sizing: border-box;
  &__l{
    width: 280px;
    background: #FFF;
    height:100%;
    margin-right: 20px;
  }
  &__r{
    width: calc(100% - 300px);
    background: #FFF;
    height:100%;
  }
}
</style>